import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styles from "./evidenceKeyModal.module.scss";
import { useTranslation } from "react-i18next";



interface EvidenceKeyModalProps {
  open: boolean;
  onClose: () => void;
  onSubmitKey: (key: string) => void;
  onContinueWithoutKey: () => void;
  error?: string;
}

const EvidenceKeyModal: React.FC<EvidenceKeyModalProps> = ({
  open,
  onClose,
  onSubmitKey,
  onContinueWithoutKey,
  error
}) => {
  const [key, setKey] = useState("");
  const [localError, setLocalError] = useState("");
  const { t } = useTranslation();


  const handleOk = () => {
    if (/^[A-Za-z0-9]{8}$/.test(key.trim())) {
      setLocalError("");
      onSubmitKey(key.trim());
      // onClose();
    } else {
      setLocalError(t("EvidenceKeyModal.EvidenceKeyError"));
    }
  };

  const handleContinue = () => {
    setLocalError("");
    onContinueWithoutKey();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={() => {}}
      center
      showCloseIcon={false}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      classNames={{
              modal: styles.modal,
            }}
    >
      <h3 className={styles.title}>{t("EvidenceKeyModal.Title")}</h3>

      <p className={styles.description}>
        {t("EvidenceKeyModal.Description")}
      </p>

      <input
        type="text"
        placeholder={t("EvidenceKeyModal.KeyPlaceholder")}
        maxLength={8}
        value={key}
        onChange={(e) => setKey(e.target.value)}
        className={styles.input}
      />

      {(localError || error) && (
        <p className={styles.error}>{localError || error}</p>
      )}

      <div className={styles.buttonContainer}>
        <button className={styles.secondaryButton} onClick={handleContinue}>
          {t("EvidenceKeyModal.ContinueWithoutKey")}
        </button>
        <button className={styles.primaryButton} onClick={handleOk}>
          {t("EvidenceKeyModal.Ok")}
        </button>
      </div>
    </Modal>
  );
};

export default EvidenceKeyModal;
